import { useLocationContext } from 'contexts/LocationContext';
import { useSnowplow } from 'contexts/SnowplowContext';
import { useEffect } from 'react';
import { yleContextGenerator } from 'services/snowplowAnalytics/contextGenerators';
import { trackPageView } from 'services/snowplowAnalytics/snowplowAnalytics';
import { useUILanguage } from './useUILanguage';
import { Analytics } from '@yleisradio/areena-types';

export function useTrackSnowplowPageView(
  analytics: Analytics | undefined
): void {
  const { isSnowplowReady } = useSnowplow();
  const { country_code: countryCode } = useLocationContext() || {};
  const language = useUILanguage();
  const ylePageloadAnalytics = analytics?.pageload?.yle;

  useEffect(() => {
    if (isSnowplowReady && countryCode && ylePageloadAnalytics) {
      const section = ylePageloadAnalytics['areena_view_type'] || 'page';
      const yleContext = yleContextGenerator({
        countryCode,
        language,
        section,
      });

      trackPageView(yleContext);
    }
  }, [isSnowplowReady, countryCode, ylePageloadAnalytics, language]);
}
